"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.getInstantWinWinnersLoadingSelector = exports.getInstantWinWinnersMetaSelector = exports.getInstantWinWinnersDataSelector = exports.getIsWonInstantWinSelector = exports.getInstantWinPrizesLoadingSelector = exports.getInstantWinPrizesDataSelector = void 0;

var _reselect = require("reselect");

var _get = _interopRequireDefault(require("lodash/get"));

var getInstantWinSelector = function getInstantWinSelector(state) {
  return (0, _get["default"])(state, 'instantWin');
};

var getInstantWinPrizeSelector = (0, _reselect.createSelector)([getInstantWinSelector], function (instantWin) {
  return (0, _get["default"])(instantWin, 'prizes');
});
var getInstantWinPrizesDataSelector = (0, _reselect.createSelector)([getInstantWinPrizeSelector], function (prizes) {
  return (0, _get["default"])(prizes, 'data');
});
exports.getInstantWinPrizesDataSelector = getInstantWinPrizesDataSelector;
var getInstantWinPrizesLoadingSelector = (0, _reselect.createSelector)([getInstantWinPrizeSelector], function (prizes) {
  return (0, _get["default"])(prizes, 'isLoading');
});
exports.getInstantWinPrizesLoadingSelector = getInstantWinPrizesLoadingSelector;
var getInstantWinHasWonSelector = (0, _reselect.createSelector)([getInstantWinSelector], function (instantWin) {
  return (0, _get["default"])(instantWin, 'hasWonInstantWin');
});
var getIsWonInstantWinSelector = (0, _reselect.createSelector)([getInstantWinHasWonSelector], function (isWon) {
  return (0, _get["default"])(isWon, 'isWon');
});
exports.getIsWonInstantWinSelector = getIsWonInstantWinSelector;
var getInstantWinWinnersSelector = (0, _reselect.createSelector)([getInstantWinSelector], function (instantWin) {
  return (0, _get["default"])(instantWin, 'winners');
});
var getInstantWinWinnersDataSelector = (0, _reselect.createSelector)([getInstantWinWinnersSelector], function (instantWin) {
  return (0, _get["default"])(instantWin, 'data');
});
exports.getInstantWinWinnersDataSelector = getInstantWinWinnersDataSelector;
var getInstantWinWinnersMetaSelector = (0, _reselect.createSelector)([getInstantWinWinnersSelector], function (instantWin) {
  return (0, _get["default"])(instantWin, 'meta');
});
exports.getInstantWinWinnersMetaSelector = getInstantWinWinnersMetaSelector;
var getInstantWinWinnersLoadingSelector = (0, _reselect.createSelector)([getInstantWinWinnersSelector], function (instantWin) {
  return (0, _get["default"])(instantWin, 'isLoading');
});
exports.getInstantWinWinnersLoadingSelector = getInstantWinWinnersLoadingSelector;
var _default = {
  getIsWonInstantWinSelector: getIsWonInstantWinSelector,
  getInstantWinPrizesDataSelector: getInstantWinPrizesDataSelector,
  getInstantWinPrizesLoadingSelector: getInstantWinPrizesLoadingSelector,
  getInstantWinWinnersDataSelector: getInstantWinWinnersDataSelector,
  getInstantWinWinnersLoadingSelector: getInstantWinWinnersLoadingSelector,
  getInstantWinWinnersMetaSelector: getInstantWinWinnersMetaSelector
};
exports["default"] = _default;
//# sourceMappingURL=selectors.js.map